export const ERROR_IN_DATA = "Errors in data";
export const SPECIAL_CHARS = /^[A-Za-z0-9_/-]+(?: [A-Za-z0-9_/-]+)*$/;
export const DUPLICATE_SET_ID =
  "There are duplicate records present in the file with respect to Set ID in row number ";
export const INVALID_BU_TYPE = "Invalid BU-Asset Type";
export const INVALID_BU_TYPE_ERR= "contains invalid BU-Asset Type entries";
export const INVALID_HURDLE_RATE = "Invalid Hurdle Rate";
export const INVALID_HURDLE_RATE_ERR = 
  "There are invalid records in the file with respect to OSA Hurdle Rate, Facings Hurdle Rate,Stock Hurdle Rate in row number";
export const INVALID_DATE_FORMAT = "Invalid date format";
export const INVALID_DATE_FORMAT_ERR = "contains invalid date format";
export const INVALID_SET_ID_FORMAT = "Invalid SET ID format";
export const INVALID_SET_ID_FORMAT_ERR = "constains invalid Set ID format";
export const INVALID_DATA_ERROR = "Invalid data error";
export const INVALID_CHAR = "Special characters or Blank space";
export const INVALID_CHAR_ERROR =
  "There are blank space in prefix or suffix of values or special characters in row number";
export const INCONSISTENT_DISPLAY_ERR = "Inconsistent Display ID";
export const INCONSISTENT_SET_ERR = "Inconsistent Set ID";
export const INVALID_DISPLAY_FORMAT = "Invalid Display ID Format";
export const INVALID_PRODUCT_ORDER = "Invalid Product Order";
export const INVALID_IS_OPTIONAL = "Invalid Is Optional Field";
export const INVALID_PAYOUT_AMOUNT = "Invalid Payout Amount";
export const INVALID_OVERLAPPING_CONDITIONS = "Invalid Overlapping Conditions";
export const DUPLICATE_OUTLETS =
  "There are duplicate records present in the file with respect to Set ID, Display ID & Outlet ID in row number ";
export const DUPLICATE_DISPLAYS =
  "There are duplicate records present in the file with respect to Display ID, Display Name & Product Code in row number ";
export const DUPLICATE_MOBILE = "Mobile is not unique in row ";
export const DUPLICATE_JOURNEY_PLAN = "Journey plan code is not unique in row "
export const INVALID_TARGET_VALUE = "Invalid Target Value"
export const INVALID_REPLACEMENT_SKU = "Invalid Replacement SKUs"
export const INVALID_PACK_TYPE = "Invalid Pack Type"
export const DUPLICATE_OUTLET_MAPPING = "There are duplicate records present in the file with respect to Outlet ID & POSM ID in row number ";
export const DUPLICATE_SURVEY_OUTLET = "There are duplicate records present in the file with respect to Outlet Code & Survey Name in row number ";
export const DUPLICATE_SOS_OUTLET = "There are duplicate records present in the file with respect to Outlet Code & Category List Name in row number ";
export const DUPLICATE_POSM_SET_MAPPING = "There are duplicate records present in the file with respect to SET ID & POSM ID in row number ";
export const DUPLICATE_FIELD_FORCE = "There are duplicate records present in the file in row number ";